import { TextTreatmentFlow } from './text_treatments';
import { TextTreatmentElement } from './text_treatments';
import { TreatmentTarget } from '../treatments/treatment_target';


export class TextTodTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  selectOption(option) {
    let optionsContainer = this.querySelector(".text_tod_options");
    let defaultOption = this.querySelector("text-tod-default");
    optionsContainer.children.forEach((item, index) => {item.setSelected(false)});
    defaultOption.setSelected(false)
    option.setSelected(true);

    this.querySelectorAll(':scope > text-treatment-flow').forEach((item, index) => {item.classList.add('hidden')})
    if(option.tagName == "TEXT-TOD-DEFAULT") {
      this.querySelector(':scope > text-treatment-flow.default-flow').classList.remove('hidden');
    } else {
      this.querySelectorAll(':scope > text-treatment-flow:not(.default-flow)')[Array.prototype.indexOf.call(optionsContainer.children, option)].classList.remove('hidden');
    }
  }

  removeOption(option) {
    let optionsContainer = this.querySelector(".text_tod_options");
    this.querySelectorAll(':scope > text-treatment-flow:not(.default-flow)')[Array.prototype.indexOf.call(optionsContainer.children, option)].remove();
    let selectFirstOption = !option.hidden;
    option.remove();

    if(selectFirstOption) this.selectOption(optionsContainer.children[0])

  }

  getIcon() {
    return 'fa-th'
  }

  static getType() {
    return "TOD"
  }

  getData() {
    let target = [];

    this.querySelectorAll(":scope > .ct_tod_action text-tod-option").forEach(function(option, index) {
      let tod_child = option.getData();
      this.querySelectorAll(":scope > text-treatment-flow:not(.default-flow)")[index].getData(tod_child);
      target.push(tod_child);
    }.bind(this));

    
    let default_flow = this.querySelector(":scope > text-treatment-flow.default-flow")
    // Only save default if it is set.
    if(default_flow.hasData()) {
      let tod_default_child = this.querySelector("text-tod-default").getData();
      default_flow.getData(tod_default_child);
      target.push(tod_default_child);
    }

    let tod_data = target.map(data => {
      return {
        tod_ranges: data.tod_ranges,
        message: {
          message_type: data.message_type,
          text: data.text,
          message_responses: data.message_responses
        }
      }
    })

    return {value: tod_data, type: TextTodTreatment.getType()}
  }

  validate() {
    let response = {requiredMissing: false, errorMessages: []};

    let invalid_tod_options = false;
    this.querySelectorAll(':scope > .ct_tod_action text-tod-option').forEach((tod_option) => { 
      if(!tod_option.validate()) {
        invalid_tod_options = true;
      }
    });
    if(invalid_tod_options) {
      response.errorMessages.push("Schedule time ranges incorrect.");
    }

    this.querySelectorAll(':scope > text-treatment-flow:not(.default-flow)').forEach(function(flow, index) {
      let flow_validation = flow.validate();
      if(flow_validation.requiredMissing) {
        response.requiredMissing = true;
      }
      Array.prototype.push.apply(response.errorMessages, flow_validation.errorMessages);

    
      flow.closest('text-tod-treatment').querySelectorAll(':scope > .ct_tod_action text-tod-option')[index].classList.remove("error");
      if(flow_validation.requiredMissing || (flow_validation.errorMessages != null && flow_validation.errorMessages.length > 0) ) {
        flow.closest('text-tod-treatment').querySelectorAll(':scope > .ct_tod_action text-tod-option')[index].classList.add("error");
      }
    }); 

    let default_flow = this.querySelector(':scope > text-treatment-flow.default-flow');
    let default_flow_validation = default_flow.validate(true);
    if(default_flow_validation.requiredMissing) {
      response.requiredMissing = true;
    }
    Array.prototype.push.apply(response.errorMessages, default_flow_validation.errorMessages);

    default_flow.closest('text-tod-treatment').querySelector(':scope > .ct_tod_action text-tod-default').classList.remove("error");
    if(default_flow_validation.requiredMissing || (default_flow_validation.errorMessages != null && default_flow_validation.errorMessages.length > 0) ) {
      default_flow.closest('text-tod-treatment').querySelector(':scope > .ct_tod_action text-tod-default').classList.add("error");
    }
    
    let first_error = this.querySelector(":scope > .ct_tod_action text-tod-option.error");
    if(first_error != null) {
      this.selectOption(first_error);
    }
    return response;
  }

  connectedCallback() {
    this.innerHTML = 
      `
      <style>
        
      </style>
      <div class="col-sm-12 ct_action ct_tod_action" data-action_type="text_tod">
        <div class="panel panel-default">
          <h4>Schedule</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <p>Create a schedule that determines how your calls should be routed.</p>
          <div>
            <div class="text_tod_options">
            </div>
            <text-tod-default></text-tod-default>
            <a href="" class="new-schedule btn btn-success">Add new schedule</a>

          </div>
        </div>
      </div>
      <div class="option_path">
        <div class="col-sm-12 ct_line">
          <div class="bottom_line"></div>
          <div class="ct_vertical_arrow"></div>
          <div class="option_text">Chat begin time matches schedule</div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div>
      </div> 
    `;

    let optionsContainer = this.querySelector(".text_tod_options")
    
    this.querySelector("a.new-schedule").addEventListener("click", function(e) {
      e.preventDefault();
      let option = document.createElement("text-tod-option");
      let optionFlow = document.createElement("text-treatment-flow");
      optionFlow.flowChanged = () => {};
      optionFlow.appendChild(document.createElement("text-treatment-element"))
      
      optionsContainer.appendChild(option);
      this.appendChild(optionFlow);

      this.selectOption(option);

      this.relabelTodOptions();
    }.bind(this));


    // Add default TOD treatment-flow
    let optionFlow = new TextTreatmentFlow();
    optionFlow.classList.add("default-flow");
    optionFlow.flowChanged = () => {};
    let treatmentElement = new TextTreatmentElement(true);
    optionFlow.appendChild(treatmentElement);
    this.appendChild(optionFlow);
    
    if(this.message != null) {
      this.sortTargetData();
      this.message.message_responses.forEach(function(child, index) {
        if(child.tod_day_map == 127 && child.tod_start_time == "0000" && child.tod_end_time == "2400") {
          let defaultFlow = this.querySelector("text-treatment-flow.default-flow")
          defaultFlow.innerHTML = "";
          defaultFlow.renderFlow(child.message);
        } else {
          let option = document.createElement("text-tod-option");
          let optionFlow = document.createElement("text-treatment-flow");
          option.target_child = child;
          optionFlow.renderFlow(child.message);

          optionsContainer.appendChild(option);
          this.appendChild(optionFlow);
        }
      }.bind(this));
      this.relabelTodOptions();
    } else {
      this.querySelector("a.new-schedule").click();
    }

    super.connectedCallback();
  }

  relabelTodOptions() {
    this.querySelectorAll("text-tod-option").forEach((elem, index) => {elem.setOptionLabel(index+1)});
    if(this.querySelector("text-tod-option.selected") == null) {

    }
    this.querySelector("text-tod-option").click();
  }

  sortTargetData() {
    let sorted_children = [];

    this.message.message_responses.forEach(function(child){
      if(child.tod_day_map == 127 && child.tod_start_time == "0000" && child.tod_end_time == "2400"){ // IF DEFAULT CHILD
        sorted_children.push(child);
      }
      else {
        let found_child = sorted_children.find(sorted_child => {
          let match_found = false;
          if(sorted_child.message != null && child.message != null) {
            match_found = sorted_child.message.message_id == child.message.message_id
          } 
          return match_found;
        });
        if(found_child) {
          found_child.tod_ranges.push({
            tod_day_map: child.tod_day_map,
            tod_start_time: child.tod_start_time,
            tod_end_time: child.tod_end_time
          });
        } else {
          let new_child = {
            tod_ranges: [{
              tod_day_map: child.tod_day_map,
              tod_start_time: child.tod_start_time,
              tod_end_time: child.tod_end_time
            }],
            message: child.message,
          }
          sorted_children.push(new_child);
        }
      }
    });
    this.message.message_responses = sorted_children;
  }
}

customElements.define('text-tod-treatment', TextTodTreatment);


class TextTodOption extends HTMLElement {
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    let data = {
      tod_ranges: [],
      message_responses: []
    };
    this.querySelectorAll("text-tod-range").forEach(function(range){
      data.tod_ranges.push(range.getData());
    }.bind(this));
    return data;
  }

  setOptionLabel(num) {
    this.querySelector(".title h5").innerHTML = `Schedule ${num}`
  }

  validate() {
    let is_valid = true;
    this.querySelectorAll("text-tod-range").forEach(function(range) {
      if(!range.validate()) {
        is_valid = false;
      }
    });

    return is_valid;
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          
        </style>
        <div class="row no-gutters" style="margin-bottom:5px; position:relative;">
          
          <div class="row">
              <div class="col-md-12 title">  
                <h5></h5><a href="#" class="remove_tod_option">remove</a>
              </div>
              <div class="col-md-12 times-container">
              </div>
          </div>


          <div class="ct_arrow"></div>
        </div>`

    this.addEventListener('click', function(event) {
      if(event.target.tagName != "SPAN" && event.target.tagName != "A") {
        this.closest("text-tod-treatment").selectOption(this);
      }
    }.bind(this));

    this.querySelector(".remove_tod_option").addEventListener("click", function(e){
      e.preventDefault();
      let tod_treatment = this.closest("text-tod-treatment");
      tod_treatment.removeOption(this);
      tod_treatment.relabelTodOptions();
    }.bind(this));
    
    if(this.target_child && this.target_child.tod_ranges) {
      this.target_child.tod_ranges.forEach(function(range) {
        let tod_range = new TextTodRange(this.addTimeRange.bind(this), range);
        this.querySelector(".times-container").appendChild(tod_range);
      }.bind(this));    
    } else {
      this.addTimeRange();
    }
  }

  addTimeRange() {
    this.querySelector(".times-container").appendChild(new TextTodRange(this.addTimeRange.bind(this)));
  }
}

customElements.define('text-tod-option', TextTodOption);

class TextTodDefault extends HTMLElement {
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    return {
      tod_ranges: [{
        tod_day_map: 127,
        tod_start_time: "0000",
        tod_end_time: "2400"
      }],
      message_responses: []
    };
  }

  setOptionLabel(num) {
    this.querySelector(".title h5").innerHTML = `Schedule ${num}`
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          text-tod-option.selected div.title, text-tod-option.selected div.times-container{
            background-color: #9ab6d382;
            border-left: 2px solid #212c5a;
            padding-bottom: 10px;
          }
          text-tod-option div.title h5 {
            margin: 10px 0px;
            display: inline-block;
          }

          text-tod-option .times .form-control {
            display: inline;
          }

          text-tod-option .remove_tod_option {
            margin-left: 30px;
          }
        </style>
        <div class="row no-gutters" style="margin-bottom:5px; position:relative;">
          
          <div class="row">
              <div class="col-md-12 title">  
                <h5>Default Option</h5>
                <p>Set a default treatment for anything that does not match your times.</p>
              </div>
          </div>


          <div class="ct_arrow"></div>
        </div>`

    this.addEventListener('click', function(event) {
      if(event.target.tagName != "SPAN" && event.target.tagName != "A") {
        this.closest("text-tod-treatment").selectOption(this);
      }
    }.bind(this));
  }
}

customElements.define('text-tod-default', TextTodDefault);


class TextTodRange extends HTMLElement {
  constructor(addTimeRange, range=null) {
    super();
    this.addTimeRange = addTimeRange;
    this.range = range;
  }

  getData() {
    let tod_start_time = "0000";
    let tod_end_time = "2400";
    if(this.querySelector("select[name=range_type]").value == 0) {
      tod_start_time = this.querySelector("select[name=tod_start_hour]").value + this.querySelector("select[name=tod_start_minute]").value
      tod_end_time = this.querySelector("select[name=tod_end_hour]").value + this.querySelector("select[name=tod_end_minute]").value
    }
    return {
      tod_day_map: this.querySelector("select[name=days]").value,
      tod_start_time: tod_start_time,
      tod_end_time: tod_end_time,
    }
  }

  validate() {
    let data = this.getData()
    return Number(data.tod_start_time) < Number(data.tod_end_time) && Number(data.tod_end_time) <= 2400
  }

  connectedCallback() {
    this.innerHTML = `
        
            <div class="col-sm-3">
              <select name="days" class="form-control">
                <option value=127>Any Day</option>
                <option value=62>Weekdays</option>
                <option value=65>Weekends</option>
                <option value=2>Monday</option>
                <option value=4>Tuesday</option>
                <option value=8>Wednesday</option>
                <option value=16>Thursday</option>
                <option value=32>Friday</option>
                <option value=64>Saturday</option>
                <option value=1>Sunday</option>
              </select>
            </div>
            <div class="col-sm-3">
            <select name="range_type" class="form-control">
                <option value=0>Between</option>
                <option class="all_day" value=1 hidden>All Day</option>
              </select>
            </div>
            <div class="col-sm-6 times">
              <select name="tod_start_hour" class="form-control" style="width:auto">
                <option checked value="00">12 AM</option>
                <option value="01">1 AM</option>
                <option value="02">2 AM</option>
                <option value="03">3 AM</option>
                <option value="04">4 AM</option>
                <option value="05">5 AM</option>
                <option value="06">6 AM</option>
                <option value="07">7 AM</option>
                <option value="08">8 AM</option>
                <option value="09">9 AM</option>
                <option value="10">10 AM</option>
                <option value="11">11 AM</option>
                <option value="12">12 PM</option>
                <option value="13">1 PM</option>
                <option value="14">2 PM</option>
                <option value="15">3 PM</option>
                <option value="16">4 PM</option>
                <option value="17">5 PM</option>
                <option value="18">6 PM</option>
                <option value="19">7 PM</option>
                <option value="20">8 PM</option>
                <option value="21">9 PM</option>
                <option value="22">10 PM</option>
                <option value="23">11 PM</option>
              </select>
              :
              <select name="tod_start_minute" class="form-control" style="width:auto">
                <option>00</option>
                <option>05</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>35</option>
                <option>40</option>
                <option>45</option>
                <option>50</option>
                <option>55</option>
              </select>
              &
              <select name="tod_end_hour" class="form-control" style="width:auto">
                <option checked value="00">12 AM</option>
                <option value="01">1 AM</option>
                <option value="02">2 AM</option>
                <option value="03">3 AM</option>
                <option value="04">4 AM</option>
                <option value="05">5 AM</option>
                <option value="06">6 AM</option>
                <option value="07">7 AM</option>
                <option value="08">8 AM</option>
                <option value="09">9 AM</option>
                <option value="10">10 AM</option>
                <option value="11">11 AM</option>
                <option value="12">12 PM</option>
                <option value="13">1 PM</option>
                <option value="14">2 PM</option>
                <option value="15">3 PM</option>
                <option value="16">4 PM</option>
                <option value="17">5 PM</option>
                <option value="18">6 PM</option>
                <option value="19">7 PM</option>
                <option value="20">8 PM</option>
                <option value="21">9 PM</option>
                <option value="22">10 PM</option>
                <option value="23">11 PM</option>
                <option value="24">End of Day</option>
              </select>
              :
              <select name="tod_end_minute" class="form-control" style="width:auto">
                <option>00</option>
                <option>05</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>35</option>
                <option>40</option>
                <option>45</option>
                <option>50</option>
                <option>55</option>
              </select>

              <a href="#" class="remove_tod_range" style="margin-left: 10px;"><i class="fa fa-minus"></i></a>
              <a href="#" class="add_tod_range" style="margin-left: 10px;"><i class="fa fa-plus"></i></a>
            </div>
          </div>`

      this.querySelector("select[name=range_type]").addEventListener("change", function(e) {
        if(e.target.value == 1) {
          this.querySelector(".times").classList.add("hide");
        } else {
          this.querySelector(".times").classList.remove("hide");
        }
      }.bind(this));

      this.querySelector("select[name=days]").addEventListener("change", function(e) {
        if(e.target.value == 127) {
          this.querySelector("select[name=range_type]").value = 0;
          this.querySelector("select[name=range_type] option.all_day").setAttribute("hidden", true);
        } else {
          this.querySelector("select[name=range_type] option.all_day").removeAttribute("hidden");
        }
        const change_event = new Event("change");
        this.querySelector("select[name=range_type]").dispatchEvent(change_event);
      }.bind(this));

      if(this.range) {
        this.querySelector("select[name=days]").value = this.range.tod_day_map
        let all_day = this.range.tod_start_time == "0000" && this.range.tod_end_time == "2400";
        this.querySelector("select[name=range_type]").value = all_day ? 1 : 0;
        if(all_day) this.querySelector(".times").classList.add("hide");
        this.querySelector("select[name=tod_start_hour]").value = this.range.tod_start_time.slice(0,2)
        this.querySelector("select[name=tod_start_minute]").value = this.range.tod_start_time.slice(2,4)
        this.querySelector("select[name=tod_end_hour]").value = this.range.tod_end_time.slice(0,2)
        this.querySelector("select[name=tod_end_minute]").value = this.range.tod_end_time.slice(2,4)
      }

      this.querySelector(".add_tod_range").addEventListener("click", function(e) {e.preventDefault(); this.addTimeRange()}.bind(this));
      this.querySelector(".remove_tod_range").addEventListener("click", function(e) {e.preventDefault(); this.remove()}.bind(this));
  }
}

customElements.define('text-tod-range', TextTodRange);
